import { useQuery } from 'react-query'
import client from '../client'

export async function getSelectedFamilyEventImage(eventSeq: string, customerNumber: string) {
  const response = await client.post<any>(`/api/search`, {
    ptcp_customer: customerNumber,
    PTCP_EVNT_SEQ: eventSeq,
    requestApi: 'getAllSelectedFamilyEventImageUri',
  })

  // 좀 복잡해서 그냥 복붙함
  if (response.data.hasOwnProperty('result')) {
    const resultObjectMap = response.data.result.map
    if (resultObjectMap.hasOwnProperty('RESP_RESULT')) {
      //console.log('getSelectedFamilyEventImage', response)

      return {
        photoDictCnt: resultObjectMap.RESP_RESULT.myArrayList.length,
        photoDictContents: resultObjectMap.RESP_RESULT.myArrayList,
      }
    }
  }

  return { photoDictCnt: 0, photoDictContents: [] }
}

// export default function getSelectedFamilyEventImageQuery(eventSeq: string, customerNumber: string) {
//   // eslint-disable-next-line react-hooks/rules-of-hooks
//   const { data, isLoading, isError } = useQuery<any>(
//     getSelectedFamilyEventImage.createKey(eventSeq, customerNumber),
//     () => getSelectedFamilyEventImage(eventSeq, customerNumber),
//     {
//       refetchOnWindowFocus: false,
//       // staleTime: 1000 * 60 * 5,
//     }
//   )
//   return { data, isLoading, isError }
// }

// getSelectedFamilyEventImage.createKey = (eventSeq: string, customerNumber: string) => [
//   'eventImage',
//   eventSeq,
//   customerNumber,
// ]
